export default __webpack_public_path__ + "static/logistica-si-mobiliatate-1a8e86999e7489df19d3853001398af5.jpg";